module.exports = __webpack_public_path__ + "static/redux-diagram-4df84f77383ac0cfc0b1cbdebc062e36.jpg";